import { BookSeries } from '@fable/types'

export const getSeasonCountLabel = (series: BookSeries) => {
  const count = series.item_count
  return `${count} ${count === 1 ? 'season' : 'seasons'}`
}
